import type {MapaConversationDto} from '@devmil/contracts';
import {useId} from 'react';
import {Link} from 'react-router-dom';

import {
  MAPA_NEXT_ACTION_LABEL,
  mapaOriginCell,
  mapaStageCell,
  mapaWindowCell,
} from '../../lib/format.js';

const COLUMNS = [
  'Referência',
  'Etapa',
  'Origem',
  'Janela',
  'Próxima ação',
] as const;

/**
 * Conversas recentes, sempre pseudonimizadas. A tabela rola dentro do painel,
 * e não alarga a página: em 375px a linha inteira continua legível deslizando.
 */
export const ConversationTable = ({
  conversations,
}: {
  conversations: readonly MapaConversationDto[];
}) => {
  const headingId = useId();

  return (
    <section className="dm-panel" aria-labelledby={headingId}>
      <div className="dm-panel-head">
        <h2 id={headingId}>Conversas recentes</h2>
        <span className="dm-illustrative">PSEUDONIMIZADAS</span>
      </div>
      <div
        className="dm-table-wrap"
        tabIndex={0}
        role="group"
        aria-labelledby={headingId}
      >
        <table>
          <thead>
            <tr>
              {COLUMNS.map((column) => (
                <th key={column} scope="col">
                  {column}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {conversations.map((conversation) => (
              <tr key={conversation.reference}>
                <td>
                  {/*
                    A referência abre o detalhe da conversa. O link tem que ser
                    INVISÍVEL ao pixel: ele herda cor e peso, não sublinha, e a
                    caixa dele cobre a célula por margem negativa igual ao
                    padding, o que dá alvo de toque de 44px sem empurrar uma
                    linha sequer. Quem julga isso é a comparação de pixel, que
                    continua verde sem baseline nova.
                  */}
                  <Link
                    className="dm-cell-link"
                    to={`/mapa/${conversation.reference}`}
                    aria-label={`Abrir a conversa ${conversation.reference}`}
                  >
                    <code>{conversation.reference}</code>
                  </Link>
                </td>
                <td>{mapaStageCell(conversation)}</td>
                <td>{mapaOriginCell(conversation)}</td>
                <td>{mapaWindowCell(conversation)}</td>
                <td>{MAPA_NEXT_ACTION_LABEL[conversation.nextAction]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
